import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { ArrowBendDownRight, ArrowLeft, MapPin } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { AnswerRecord } from '../../types/AnswerRecordType';
import { Header } from '../../components/Header';
import { LoadingScreen } from '../../components/LoadingScreen';
import { t } from 'i18next';
import { formatDate } from '../../utils/formatDate';

type AnswerRecordsType = {
  answerRecordData: AnswerRecord[]
  isLoading: boolean;
  contractId?: string;
  projectId?: string;
}

export function AnswerRecords({
  answerRecordData, isLoading, contractId, projectId,
}: AnswerRecordsType) {
  const navigate = useNavigate();

  function handleGoogleMapsView(latitude: string, longitude: string) {
    window.open(`http://maps.google.com/maps?q=${latitude},${longitude}`);
  }

  return (
    <>
      {isLoading ? (
        <LoadingScreen isVisible={isLoading} />
      ) : (
        <>
          <Header />

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row', gap: 30, marginLeft: 100, marginTop: 30 }}>
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 30, flex: 1 }} >
              <Tooltip title='Voltar'>
                <ArrowLeft onClick={() => navigate(`/contracts/${contractId}/project/${projectId}`)} size={30} color='#FF9E45' cursor='pointer' />
              </Tooltip>
              <span style={{ fontWeight: 'bold', color: '#7A7A7A' }}>{t('project-records-saved')}</span>
            </div>
          </div>

          {answerRecordData.length >= 1 ? (
            <TableContainer sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', mt: 3, mb: 3 }}>
              <Table size='small' sx={{ background: '#F3F3F3', width: '90%' }}>
                <TableHead sx={{ background: '#D9D9D9' }}>
                  <TableRow>
                    <TableCell>
                      <span style={{ fontWeight: 'bold', fontSize: 16 }}>ID</span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontWeight: 'bold', fontSize: 16 }}>{t('project-records-responsible')}</span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontWeight: 'bold', fontSize: 16 }}>{t('project-records-latitude')}</span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontWeight: 'bold', fontSize: 16 }}>{t('project-records-longitude')}</span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontWeight: 'bold', fontSize: 16 }}>{t('project-records-date')}</span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontWeight: 'bold', fontSize: 16 }}>{t('project-records-actions')}</span>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {answerRecordData?.map(item => (
                    <React.Fragment key={item.id}>
                      <TableRow>
                        <TableCell>
                          <span>{item.register_id}</span>
                        </TableCell>
                        <TableCell>
                          <span>{item.owner_id}</span>
                        </TableCell>
                        <TableCell>
                          <span>{item.latitude}</span>
                        </TableCell>
                        <TableCell>
                          <span>{item.longitude}</span>
                        </TableCell>
                        <TableCell>
                          <span>{formatDate(item.created_at)}</span>
                        </TableCell>
                        <TableCell sx={{ display: 'flex', gap: 1 }}>
                          <Tooltip title='Visualizar no Google Maps'>
                            <MapPin onClick={() => handleGoogleMapsView(item.latitude, item.longitude)} size={30} color='#D76928' cursor='pointer' />
                          </Tooltip>
                          <Tooltip title={t('project-records-answers')}>
                            <ArrowBendDownRight onClick={() => navigate(`/contracts/${contractId}/project/${projectId}/answer/${item.id}`)} size={30} color='#70BC78' cursor='pointer' />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
              {answerRecordData?.length === 0 && (
                <div style={{ height: '30vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('projects-forms-warning')}</span>
                </div>
              )}
            </TableContainer>
          ) : (
            <div style={{ height: '30vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold' }}>{t('projects-forms-warning')}</span>
            </div>
          )}
        </>
      )}
    </>
  );
}
